import { LocalStorage } from '@flight-workspace/common-client/src/util/storage';
import { SelectTypeKeys } from 'list/international/types';

const localStorage = new LocalStorage<string>('selectType');
const internationalSelectTypeStorage = (): {
  getSelectTypeFromStorage: () => SelectTypeKeys | null;
  setSelectTypeToStorage: (key: SelectTypeKeys) => void;
} => ({
  getSelectTypeFromStorage: () =>
    (localStorage.get() as SelectTypeKeys) || null,
  setSelectTypeToStorage: (key: SelectTypeKeys) =>
    localStorage.set(key as string),
});

export default internationalSelectTypeStorage;
